import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AdministradoraService } from 'src/app/admihair/service/administradora.service';
import { Administradora } from 'src/app/admihair/api/dto/administradora';
import { Usuario } from 'src/app/admihair/api/dto/usuario';
import { UsuarioService } from 'src/app/admihair/service/usuario.service';
import { Table } from 'primeng/table';
import { UsuarioPermissaoAdministradora } from 'src/app/admihair/api/dto/usuario-permissao-administradora';
import { UsuarioPermissaoAdministradoraService } from 'src/app/admihair/service/usuario-permissao-administradora.service';


@Component({
  selector: 'app-administradora-detalhar',
  templateUrl: './administradora-detalhar.component.html',
  styleUrls: ['./administradora-detalhar.component.scss']
})
export class AdministradoraDetalharComponent implements OnInit {

  constructor(private administradoraService: AdministradoraService,
    private usuarioService: UsuarioService,
    private usuarioPermissaoAdministradoraService: UsuarioPermissaoAdministradoraService,
    private activatedRouter: ActivatedRoute, 
    private _router: Router
  ) { }

  id?: number;
  administradora?: Administradora;
  usuarioSelecionado?: Usuario = {};
  usuarios: Usuario[] = [];
  usuariosPermissoesAdministradoras: UsuarioPermissaoAdministradora[] = [];
  loading: boolean = false;
  exibirListaPermissoesUsuario: boolean = false;

  @ViewChild('filter') filter!: ElementRef;


  ngOnInit(): void {
    this.carregarIdUrl();
    this.carregarAdministradoraPorId();
    this.carregarUsuarioAdministradora();
  }

  carregarIdUrl(){
    const idParam = this.activatedRouter.snapshot.paramMap.get('id');
    if(idParam){
      this.id = parseInt(idParam);
    }    
  }

  carregarUsuarioAdministradora(){
    this.usuarioService.listarPorAdministradoraId(this.id).subscribe({
      next: (data: Usuario[]) => {
        this.usuarios = data;
      },
      error: (err: any) => console.log(err)
    });
  }

  carregarAdministradoraPorId(){
    this.administradoraService.buscarAdminstradoraPorId(this.id).subscribe({
      next: (data: Administradora) => {
        this.administradora = data;
      },
      error: (err: any) => {
        console.log('erro buscar contrato: ', err);
      }
    });
  }

  listarPermissaoUsuario(usuario: Usuario){
    this.exibirListaPermissoesUsuario = true;
    this.usuarioSelecionado = usuario;
    this.listarUsuariosPermissoesPorUsuarioEAdministradora();
  }

  listarUsuariosPermissoesPorUsuarioEAdministradora(){
    this.usuarioPermissaoAdministradoraService.listarPorUsuarioEAdministradora(this.usuarioSelecionado?.id, this.id).subscribe({
      next: (data: UsuarioPermissaoAdministradora[]) => {
        this.usuariosPermissoesAdministradoras = data;
      },
      error: (err: any) => console.log(err)
    });
  }

  voltar(){
    if(this.exibirListaPermissoesUsuario){
      this.exibirListaPermissoesUsuario = false;
    } else {
      this._router.navigate(["/rfarias/administradora"], { relativeTo: this.activatedRouter });
    }
  }

  buscar(table: Table, event: Event) {
    table.filterGlobal((event.target as HTMLInputElement).value, 'contains');
  }

  limpar(table: Table) {
    table.clear();
    this.filter.nativeElement.value = '';
  }

}
